import React, { useRef } from 'react';
import './List.css';
import Icon from '../home/Icon';
import { useContextMenu } from '../context/ContextMenuContext';
import { motion } from 'framer-motion';

// One wiki entry. onClick / contextMenuType only for admins (edit popup, long press / right click menu);
// without them the row is plain text without hover affordance.
function WikiListItem({id = 0, title = 'Title', description = 'desc', priority = 1, orderNumber = 1, index, withOrderNumber = false, withPriority = false, onClick, contextMenuType}) {
  //Context Menu
  const { openContextMenu } = useContextMenu();
  const interactive = !!onClick;

  const handleContextMenu = (event) => {
    openContextMenu(event, id, contextMenuType);
  };

  const listItemVariants = {
    initial: {
      opacity: 0,
      scale: 1
    },
    visible: {
      opacity: 1,
      transition: {
        delay: 0.06 * index,
        duration: 0.4
      }
    },
    hover: {
      scale: 1.01,
      cursor: "pointer"
    },
    click: {
      scale: 0.99,
      transition: {
        duration: 0.001
      }
    }
  }

  const longPressTimer = useRef(null);

  const clearLongPress = () => {
    if (longPressTimer.current !== null) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
  };

  const handleTouchStart = (event) => {
    clearLongPress();
    longPressTimer.current = setTimeout(() => {
      handleContextMenu(event);
    }, 150); // long-press duration in ms
  };

  const menuHandlers = contextMenuType
    ? { onTouchStart: handleTouchStart, onTouchMove: clearLongPress, onTouchEnd: clearLongPress, onContextMenu: handleContextMenu }
    : {};

  return (
    <motion.div
      className={`wikiListItemContainer ${withOrderNumber ? "withOrderNumber" : ""} ${withPriority ? "withPriority" : ""} ${interactive ? "isInteractive" : ""}`}
      {...menuHandlers}
      onClick={onClick}
      variants={listItemVariants}
      initial="initial"
      animate="visible"
      whileHover={interactive ? "hover" : undefined}
      whileTap={interactive ? "click" : undefined}
    >
      {withOrderNumber && <p className={"orderText"}>{orderNumber}</p>}
      <div className={"textContainer"}>
        <p className={"title"}>{title}</p>
        <p className={"desc"}>{description}</p>
      </div>
      {priority === 2 && withPriority && <Icon className={"priorityIcon"} icon='priority_high' />}
    </motion.div>
  )
}

export default WikiListItem
